import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { NotImplementedComponent } from './not-implemented/not-implemented.component';

const routes: Routes = [
    { path: '403', component: AccessDeniedComponent },
    { path: '404', component: NotFoundComponent },
    { path: 'access-denied', component: AccessDeniedComponent },
    { path: 'not-found', component: NotFoundComponent },
    { path: 'not-implemented', component: NotImplementedComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PagesRoutingModule {}
